import { inject } from 'mobx-react';
import { Link as RouterLink } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { RouteStore } from 'bernie-core';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { LocationViewModel } from 'models';

import { UitkIcon } from 'uitk-react-icons';
import { UitkIconSize } from 'uitk-react-icons/dist/uitk-icon';
import { UitkLink } from 'uitk-react-link';

const LinkTracked = ClickTracker(UitkLink);

export interface LocationSummaryProps {
  locations: LocationViewModel[];
  routeStore?: RouteStore;
  currentHotel?: CurrentHotelStore;
}

@inject('routeStore', 'currentHotel')
export class LocationSummary extends React.PureComponent<LocationSummaryProps> {
  constructor(props) {
    super(props);

    this.onPoiSelect = this.onPoiSelect.bind(this);
  }

  public render() {
    const { locations, routeStore } = this.props;
    if (!locations || locations.length === 0) {
      return null;
    }

    const locationsCount = locations.length;

    const locationSummary =
      locations &&
      locations.map((location, index) => {
        const { accessibleCategory, category, distance, name } = location;
        const categoryIconName = category === 'flight' ? 'lob_flights' : category;

        const mapOpenQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialog: 'map' });
        const link = { pathname: routeStore.pathname, search: mapOpenQuery };
        const referrerId = `PDP.PoiToMap.${index + 1}`;
        const linkName = 'Open map on Location';

        const itemPadding = locationsCount === index + 1 ? '' : 'all-b-margin-two';
        const itemClassName = `uitk-type-300 pwa-theme--grey-700 ${itemPadding}`;

        return (
          <>
            {location.id && (
              <div
                className={itemClassName}
                data-stid="location-summary"
                key={`location-${index}`}
                onClick={this.onPoiSelect}
                data-id={location.id}
              >
                <span className="uitk-grid">
                  <LinkTracked className="uitk-cell all-cell-fill" inline={true} linkName={linkName} rfrr={referrerId}>
                    <RouterLink to={link}>
                      <UitkIcon
                        className="all-r-padding-two"
                        id={`whats-around-property-location-category-${index}`}
                        name={categoryIconName}
                        title={accessibleCategory}
                        size={UitkIconSize.SMALL}
                      />
                      <span data-stid="location-name">{name}</span>
                    </RouterLink>
                  </LinkTracked>
                  <span data-stid="location-distance">{distance}</span>
                </span>
              </div>
            )}
            {!location.id && (
              <div className={itemClassName} data-stid="location-summary" key={`location-${index}`}>
                <span className="uitk-grid">
                  <UitkIcon
                    className="all-r-padding-three"
                    id={`whats-around-property-location-category-${index}`}
                    name={categoryIconName}
                    title={accessibleCategory}
                    size={UitkIconSize.SMALL}
                  />
                  <span className="uitk-cell all-cell-fill all-r-padding-two" data-stid="location-name">
                    {name}
                  </span>
                  <span data-stid="location-distance">{distance}</span>
                </span>
              </div>
            )}
          </>
        );
      });

    return <div data-stid="location-summary-list">{locationSummary}</div>;
  }

  private onPoiSelect(e) {
    const { currentHotel } = this.props;

    const locationId = e.currentTarget.dataset.id;
    currentHotel.setSelectedMapMarker(locationId);
  }
}
